<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepRymdfhResolve',
})
</script>
<template>
  <TlDetailItem title="同意-人员名单复核" color="green">
    <TlDetailField label="审核人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="审核时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="审核意见">{{ record?.shenHeYiJian }}</TlDetailField>
    <TlDetailField label="县政府批复">
      <FileDisplayNormals :files="rymdfhXianZhengFuPiFuFiles" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepRymdfhResolve">
import { computed } from 'vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
const props = defineProps<{
  record?: any
}>()
// 县政府批复
const rymdfhXianZhengFuPiFuFiles = computed(() => props.record?.files?.rymdfhXianZhengFuPiFuFiles ?? [])
</script>
